// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8d8c084","453":"5f6bdad0","455":"694171fb","977":"cfeab2ea"}[chunkId] + ".chunk.js";
};